module.exports = __webpack_public_path__ + "media/images/icon-special-65630113dfb9d32a26c51d850a08e2ab.svg";